import { render, staticRenderFns } from "./ServingSize.vue?vue&type=template&id=f2927f46&"
import script from "./ServingSize.vue?vue&type=script&lang=js&"
export * from "./ServingSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports